import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FileUploadInfo } from '../model/file-upload-info.model';

@Component({
    selector: 'app-file-upload-display',
    templateUrl: './file-upload-display.component.html',
    styleUrls: ['./file-upload-display.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FileUploadDisplayComponent {
    @Input() fileInfo: FileUploadInfo;
    @Output() removeFile = new EventEmitter<FileUploadInfo>();

    handleFileRemoval(file: FileUploadInfo) {
        this.removeFile.emit(file);
    }
}
